module.exports = __webpack_public_path__ + "open-sans-latin-700.b796ab1e0f5e3af743ea.eot";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-700.eot
// module id = ../../../../typeface-open-sans/files/open-sans-latin-700.eot
// module chunks = 1 3